export const images = [require('./evoluno/icon.png'), require('./evoluno/splash.png')];

export const fonts = {
  Quattrocento_400Regular: require('../fonts/Quattrocento-Regular.ttf'),
  Quattrocento_700Bold: require('../fonts/Quattrocento-Bold.ttf'),
  QuattrocentoSans_400Regular: require('../fonts/QuattrocentoSans-Regular.ttf'),
  QuattrocentoSans_700Bold: require('../fonts/QuattrocentoSans-Bold.ttf'),
  PublicSansBold: require('../fonts/PublicSans-Bold.otf'),
  PublicSansRegular: require('../fonts/PublicSans-Regular.otf')
};
